import React from 'react';
import styles from '../../../../../../../../theme/Juego2.module.css';
import { DiasSemana } from '../constants/diasSemana';

// Agregamos el tipo para cada pregunta
interface Pregunta {
  fecha: Date;
  opcionCorrecta: DiasSemana;
  inputUsuario: DiasSemana | null;
}

interface Props {
  correctas: number;
  total: number;
  reiniciar: () => void;
  resultadoFinal: string;
  preguntas: Pregunta[]; // 👈 nuevo
}

const Resultado: React.FC<Props> = ({ correctas, total, reiniciar, resultadoFinal, preguntas }) => {
  return (
    <div
      className={styles.resultado}
      style={{
        maxWidth: "450px",
        width: "100%",
        margin: "0 auto",
        padding: "1rem",
        textAlign: "center",
      }}
    >
      <h2 style={{
        fontSize: "clamp(1.4rem, 6vw, 2.1rem)",
        marginBottom: "0.5rem"
      }}>{resultadoFinal}</h2>
      <p style={{
        fontSize: "clamp(1rem, 4.5vw, 1.3rem)",
        marginBottom: "1.5rem",
        fontWeight: 600
      }}>
        TUVISTE {correctas}/{total - 1} RESPUESTAS CORRECTAS
      </p>

      {/* === Listado de resultados === */}
      <div
        style={{
          marginTop: '1.5rem',
          maxHeight: '45vh',
          overflowY: 'auto',
          width: '90%',
          alignSelf: 'center',
        }}
      >
        {preguntas.map((pregunta, index) => {
          const esCorrecta =
            pregunta.inputUsuario === pregunta.opcionCorrecta &&
            pregunta.inputUsuario !== null;

          const color = esCorrecta ? '#1abc9c' : '#e74c3c'; // verde / rojo
          const fechaStr = pregunta.fecha.toLocaleDateString('es', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          });

          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0.65rem 0.9rem",
                marginBottom: "0.6rem",
                borderRadius: "10px",
                background: "white",
                border: `2px solid ${color}`,
                color: color,
                fontWeight: 600,
                fontSize: "clamp(0.9rem, 4vw, 1.1rem)",   // 👈 tamaño perfecto
              }}
            >
              <span>{fechaStr}</span>
              <span>
                {pregunta.inputUsuario !== null
                  ? `${pregunta.inputUsuario} (${esCorrecta ? "✔" : `✘ ${pregunta.opcionCorrecta}`})`
                  : "Sin respuesta"}
              </span>
            </div>
          );
        })}
      </div>

      <button
        id="button_rosado_default"
        style={{ width: 'fit-content', alignSelf: 'center', marginTop: '1rem' }}
        className={styles.botonReiniciar}
        onClick={reiniciar}
      >
        JUGAR DE NUEVO
      </button>
    </div>
  );
};

export default Resultado;
